import { notification } from "antd";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { extractSignXml } from "@shared/ui";
import { usePostSignEntry } from "../mutate-hooks/use-post-sign-entry";

export const useWithSignedString = () => {
  const { mutateAsync: sendSignedXml } = usePostSignEntry();

  const withSignedString = async (
    params: {
      sectionThreeListId?: string;
      sectionListId?: string;
      itemNoVersionId: string;
      signerEmployeeId: string;
      onSuccess?: () => void;
    },
    signedXml: string,
    mchdId?: string,
  ) => {
    try {
      const signXml = extractSignXml(signedXml);

      await sendSignedXml({
        // @ts-expect-error path params подписи не совпадают с openapi типами
        params: {
          path: {
            sectionThreeListId: params.sectionThreeListId || params.sectionListId || "",
            itemNoVersionId: params.itemNoVersionId,
          },
        },
        body: {
          signer: {
            signerEmployeeId: params.signerEmployeeId,
          },
          signXml,
          ...(mchdId ? { mchdId } : {}),
        },
      });

      params.onSuccess?.();
    } catch (err: any) {
      notification.error({
        message: NOTIFICATION_MESSAGES.XML_SIGN_SEND_ERROR, // "Ошибка отправки подписи"
        description: err.response?.data?.errorDescription || "Неизвестно",
        placement: "topRight",
      });
    }
  };

  return {
    withSignedString,
  };
};
